import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73183b04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indicators-statistic" }
const _hoisted_2 = { class: "indicators-statistic__header" }
const _hoisted_3 = { class: "indicators-statistic__date-picker" }
const _hoisted_4 = { class: "indicators-statistic__report-type" }
const _hoisted_5 = { class: "indicators-statistic__content" }

import { computed, onMounted, ref } from 'vue'
import IndicatorsStatistic from '@/widgets/WIndicatorsStatistic/components/IndicatorsStatistic.vue'
import IndicatorsStatisticInfo from '@/widgets/WIndicatorsStatistic/components/IndicatorsStatisticInfo.vue'
import ru from 'element-plus/es/locale/lang/ru'
import {
  APPOINTMENTS_MODE,
  FILTER_MODE,
} from '@/widgets/WIndicatorsStatistic/constants/mode'
import { FilterModeType } from '@/widgets/WIndicatorsStatistic/types/mode.type'
import {
  ReportViewType,
  StatisticAppointmentType,
  StatisticDoctorType,
  StatisticFilterType,
  StatisticReportType,
} from '@/shared/types'
import { statisticApi } from '@/shared/api'
import { useUser } from '@/shared/composables'
import {
  getDateFormat,
  getFirstDayOfMonth,
  getLastDayOfMonth,
  showErrorMessage,
} from '@/shared/utils'
import { DATE_FORMAT, REPORT_VIEW } from '@/shared/constants'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = useUser()

const dateRange = ref([])
const filterMode = ref(FILTER_MODE.month)
const month = ref(getFirstDayOfMonth(new Date()))
const doctors = ref<StatisticDoctorType[]>([])
const reports = ref<StatisticReportType[]>([])
const screenings = ref<StatisticReportType[]>([])
const brushmaps = ref<StatisticReportType[]>([])
const periodontologies = ref<StatisticReportType[]>([])
const timelyAppointments = ref<StatisticAppointmentType[]>([])
const appointments = ref<StatisticAppointmentType[]>([])

const reportType = ref<ReportViewType>(REPORT_VIEW.plaqueIndex)

const currentReports = computed(() => {
  if (reportType.value === REPORT_VIEW.brushMap) {
    return brushmaps.value
  } else if (reportType.value === REPORT_VIEW.screening) {
    return screenings.value
  } else if (reportType.value === REPORT_VIEW.periodontal) {
    return periodontologies.value
  } else if (reportType.value === REPORT_VIEW.plaqueIndex) {
    return reports.value
  } else if (reportType.value === APPOINTMENTS_MODE.planned) {
    return appointments.value
  } else {
    return timelyAppointments.value
  }
})

const getStatistic = async (mode: FilterModeType): Promise<void> => {
  if (
    mode === 'date' &&
    Object.values(APPOINTMENTS_MODE).includes(reportType.value)
  ) {
    reportType.value = REPORT_VIEW.plaqueIndex
  }

  const filter: StatisticFilterType = setFilterByMode(mode)

  if (user.value.role === 'head_doctor') {
    const [error, response] = await statisticApi.getHeadDoctorStatistic(filter)

    getStatisticData(error, response)
  } else {
    const [error, response] = await statisticApi.getDoctorStatistic(filter)

    getStatisticData(error, response)
  }
}

const setFilterByMode = (mode: FilterModeType): StatisticFilterType => {
  const filter: StatisticFilterType = {
    dateFrom: undefined,
    dateTo: undefined,
  }

  switch (mode) {
    case FILTER_MODE.date: {
      filter.dateFrom = dateRange.value ? dateRange.value[0] : []
      filter.dateTo = dateRange.value ? dateRange.value[1] : []
      break
    }
    case FILTER_MODE.month: {
      filter.dateFrom = new Date(
        getDateFormat(month.value, DATE_FORMAT.ymdDash)
      )
      filter.dateTo = getLastDayOfMonth(month.value)
      break
    }
  }

  return filter
}

const getStatisticData = (error: any, response: any): void => {
  if (error) {
    showErrorMessage(error)
  } else {
    if (user.value.role === 'head_doctor') {
      doctors.value = response.data.doctors
    } else {
      doctors.value = response.data.doctor
    }

    timelyAppointments.value = response.data.timelyAppointments
    appointments.value = response.data.appointments
    reports.value = response.data.reports
    brushmaps.value = response.data.brushmaps
    screenings.value = response.data.screenings
    periodontologies.value = response.data.periodontologies
  }
}

onMounted((): void => {
  getStatistic(FILTER_MODE.month)
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_select, {
        modelValue: filterMode.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterMode).value = $event)),
        class: "indicators-statistic__date-mode"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            value: _unref(FILTER_MODE).date,
            label: "Выбрать даты",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (getStatistic(_unref(FILTER_MODE).date)))
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            value: _unref(FILTER_MODE).month,
            label: "Помесячно",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (getStatistic(_unref(FILTER_MODE).month)))
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_3, [
        (filterMode.value === _unref(FILTER_MODE).month)
          ? (_openBlock(), _createBlock(_component_el_config_provider, {
              key: 0,
              locale: _unref(ru)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: month.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((month).value = $event)),
                  format: "MMMM, YYYY",
                  type: "month",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (getStatistic(_unref(FILTER_MODE).month)))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["locale"]))
          : (_openBlock(), _createBlock(_component_el_config_provider, {
              key: 1,
              locale: _unref(ru)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: dateRange.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dateRange).value = $event)),
                  "end-placeholder": "Конец",
                  format: "DD.MM.YYYY",
                  "start-placeholder": "Начало",
                  type: "daterange",
                  "value-format": "YYYY-MM-DD",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (getStatistic(_unref(FILTER_MODE).date)))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["locale"]))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_select, {
          modelValue: reportType.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((reportType).value = $event)),
          class: "indicators-statistic__date-mode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              value: _unref(REPORT_VIEW).plaqueIndex,
              label: "Индекс налёта"
            }, null, 8, ["value"]),
            _createVNode(_component_el_option, {
              value: _unref(REPORT_VIEW).periodontal,
              label: "Пародонтология"
            }, null, 8, ["value"]),
            _createVNode(_component_el_option, {
              value: _unref(REPORT_VIEW).screening,
              label: "Скрининг"
            }, null, 8, ["value"]),
            _createVNode(_component_el_option, {
              value: _unref(REPORT_VIEW).brushMap,
              label: "Карта ёршиков"
            }, null, 8, ["value"]),
            (filterMode.value === _unref(FILTER_MODE).month)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_option, {
                    value: _unref(APPOINTMENTS_MODE).timely,
                    label: "Пришедшие"
                  }, null, 8, ["value"]),
                  _createVNode(_component_el_option, {
                    value: _unref(APPOINTMENTS_MODE).planned,
                    label: "Планируемые"
                  }, null, 8, ["value"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(IndicatorsStatistic, {
        reports: _unref(currentReports),
        class: "indicators-statistic__card"
      }, null, 8, ["reports"]),
      _createVNode(IndicatorsStatisticInfo, {
        doctors: doctors.value,
        reportType: reportType.value
      }, null, 8, ["doctors", "reportType"])
    ])
  ]))
}
}

})